import api from '../services/api';


const orderService = {
    // Fetch all product types
    getAll: async () => {
        try {
            const response = await api.get('/orders');
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    getById: async (id) => {
        try {
            const response = await api.get(`/orders/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },


    // Create a new category
    create: async (formData) => {
        try {
            const response = await api.post('/orders', formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    update: async (id, formData) => {
        try {
            const response = await api.put(`/orders/${id}`, formData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },

    delete: async (id) => {
        try {
            const response = await api.delete(`/orders/${id}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error;
        }
    },
};

export default orderService;
